import axios from 'axios';

const AUTHAPP_URL = process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:8081';

const getAuthHeaders = () => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    const parsedUser = JSON.parse(storedUser);
    const token = parsedUser.auth_token || parsedUser.token || parsedUser.jwt;
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
  }
  return {};
};

const smtpApiService = {
  getSmtpConfig: async () => {
    try {
      const response = await axios.get(`${AUTHAPP_URL}/api/smtp/config`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  saveSmtpConfig: async (configData) => {
    try {
      const response = await axios.post(`${AUTHAPP_URL}/api/smtp/config`, configData, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  testSmtpConfig: async (email, configData) => {
    try {
      const payload = { email, ...configData };
      const response = await axios.post(`${AUTHAPP_URL}/api/smtp/test`, payload, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default smtpApiService;
